import { render, staticRenderFns } from "./McSvg.vue?vue&type=template&id=7e6c22b2&scoped=true"
import script from "./McSvg.vue?vue&type=script&lang=js"
export * from "./McSvg.vue?vue&type=script&lang=js"
import style0 from "./McSvg.vue?vue&type=style&index=0&id=7e6c22b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6c22b2",
  null
  
)

export default component.exports